// router imports
import { Navigate, useLocation } from 'react-router-dom';

// utils
import SessionStorage from '../../utils/SessionStorage';

const UnprotectedRoute = ({ children }) => {
  // Vars
  const token = SessionStorage.get('token');

  // Hooks
  const location = useLocation();

  if (token) {
    return <Navigate to="/users/list" state={{ from: location }} replace />;
  } else {
    return children;
  }
};

export default UnprotectedRoute;
